import React, { useEffect, useState } from "react";
import Icon from "../../../assets/Icon";
import { Card } from "antd";
import { Link } from "react-router-dom";
import { reportGetShotImgApi } from "../../../api";
import WebUtils from "../../utils/WebUtils";

function VideoClips({ config, imgShot, loginQuery }) {
  const [enlargedImage, setEnlargedImage] = useState(null);

  const handleImageClick = (src) => {
    setEnlargedImage(src);
  };

  const closeModal = () => {
    setEnlargedImage(null);
  };
  // console.log(imgShot)
  return (
    <div className="mt-10">
      {" "}
      <div className="flex justify-between">
        <div className="flex gap-3 items-center font-semibold text-[1.275rem]">
          <p className="bg-[#206DC5] border inline-block p-3 rounded-xl">
            <Icon type="video-analysis-icon" width="18" height="19" />
          </p>
          <span>Video Recording</span>
        </div>
        <Link to={`/interview-analysis/?q=${loginQuery}`} target="_blank">
          <button className="flex items-center justify-center gap-2 px-4 py-3 bg-[#206DC5] text-white font-semibold rounded-md">
            <Icon type="video-edit-icon" width="20" height="22" />{" "}
            <span className="print:block md:block hidden text-[.95rem]">
              Watch Interview Recording
            </span>
          </button>
        </Link>
      </div>
      <Card className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]">
        <p className="text-[#475467] text-lg font-semibold pb-2">
          Screenshots{" "}
        </p>

        {config?.screenRecordingRequired ? (
          <div className="screenshot-container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 rounded-md">
            {imgShot?.screenshotList?.length > 0 &&
              imgShot.screenshotList.map((item, i) => (
                <img
                  key={i}
                  src={item}
                  alt=""
                  className="rounded-md cursor-pointer hover:scale-110 transition-all duration-200 ease-in-out"
                  onClick={() => handleImageClick(item)}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ))}
          </div>
        ) : (
          <div className="mt-2 mx-auto">
            <p className="text-center flex justify-center">
              <Icon type="lock-orientation-icon" width="50" height="50" />
            </p>
            <p className=" text-[#475467] text-center mt-1">
              Upgrade/Enable to unlock all screen recording premium features.
            </p>
            <div className="text-[#475467] text-center">
              Contact{" "}
              <a
                href="mailto:support@hireplusplus.com"
                className="text-[#206DC5] hover:text-blue-400 font-medium"
              >
                support@hireplusplus.com
              </a>{" "}
              to Upgrade/Enable.
            </div>
          </div>
        )}

        {enlargedImage && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50"
            onClick={closeModal}
          >
            <img
              src={enlargedImage}
              alt="Enlarged"
              className="max-w-full max-h-full rounded-md"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              className="absolute top-4 right-4 text-white text-2xl"
              onClick={closeModal}
            >
              &times;
            </button>
          </div>
        )}
      </Card>
      <Card className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]">
        <p className="text-[#475467] text-lg font-semibold pb-2">Snapshots </p>

        {config?.videoRecordingRequired ? (
          <div className="snapshot-container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 rounded-md">
            {imgShot?.snapshotList?.length > 0 &&
              imgShot.snapshotList.map((item, i) => (
                <img
                  key={i}
                  src={item}
                  alt=""
                  className="rounded-md cursor-pointer hover:scale-110 transition-all duration-200 ease-in-out"
                  onClick={() => handleImageClick(item)}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ))}
          </div>
        ) : (
          <div className="mt-2 mx-auto">
            <p className="text-center flex justify-center">
              <Icon type="lock-orientation-icon" width="50" height="50" />
            </p>
            <p className=" text-[#475467] text-center mt-1">
              Upgrade/Enable to unlock all video recording premium features.
            </p>
            <div className="text-[#475467] text-center">
              Contact{" "}
              <a
                href="mailto:support@hireplusplus.com"
                className="text-[#206DC5] hover:text-blue-400 font-medium"
              >
                support@hireplusplus.com
              </a>{" "}
              to Upgrade/Enable.
            </div>
          </div>
        )}
        {enlargedImage && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50"
            onClick={closeModal}
          >
            <img
              src={enlargedImage}
              alt="Enlarged"
              className="max-w-full max-h-full rounded-md"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              className="absolute top-4 right-4 text-white text-2xl"
              onClick={closeModal}
            >
              &times;
            </button>
          </div>
        )}
      </Card>
    </div>
  );
}

export default VideoClips;
